
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { adminGetSchoolRecordListApi, adminGetSchoolRecordVer2ListApi } from '../../../api/admin/schoolRecord'
import { swalErrorAlert } from '../../../utils/swal/swal'
import TablePagination from '../../common/TablePagination'

const SchoolRecordVer2List = ({ userId, searchTerm, adminType }) => {
    const [schoolRecordList, setSchoolRecordList] = useState([])

    useEffect(() => {
        const getSchoolRecordList = async (userId, searchTerm) => {
            try {
                const response = await adminGetSchoolRecordVer2ListApi(userId, searchTerm)
                if (response.data.code === 200) { setSchoolRecordList(response.data.resData) }
                return

            } catch (error) {
                console.log(error);
                swalErrorAlert('생활기록부 조회 에러', '생활기록부 리스트를 조회하는 도중에 에러가 발생하였습니다.')
                return
            }
        }

        getSchoolRecordList(userId, searchTerm)
    }, [userId, searchTerm])


    /* Pagination */
    const itemsPerPage = 10
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = schoolRecordList.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(schoolRecordList.length / itemsPerPage);
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % schoolRecordList.length;
        setItemOffset(newOffset);
    };

    return (
        <div className="">
            <table className="user-list-table table table-bordered dataTable" id="dataTable" cellSpacing="{0}">
                <colgroup>
                    <col width={"80px"} />
                    <col width={"auto"} />
                    <col width={"160px"} />
                    <col width={"200px"} />
                </colgroup>
                <thead>
                    <tr className='table-secondary text-center'>
                        <th>번호</th>
                        <th>제목</th>
                        <th>작성일</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody style={{ maxHeight: "calc(100vh - 450px)", overflowX: "auto" }}>
                    {currentItems.map((item, idx) => {
                        let no = schoolRecordList.length - itemOffset - idx;
                        return (
                            <tr key={'currentItems-' + item.school_record_id}>
                                <td className='text-center'>{no}</td>
                                <td>{item.title}</td>
                                <td className='text-center'>{item.created_at}</td>
                                <td className='text-center'>
                                    <Link to={`/hy-admin/school-record/read/${item.user_id}/${item.school_record_id}`} className='btn btn-outline-secondary btn-sm ms-2'>조회</Link>
                                    {adminType === 'admin' && (
                                        <Link to={`/hy-admin/school-record/update/${item.user_id}/${item.school_record_id}`} className='btn btn-primary btn-sm ms-2'>수정</Link>
                                    )}
                                </td>
                            </tr>
                        )
                    })}

                    {schoolRecordList.length === 0 && (
                        searchTerm === '' ? (
                            <tr>
                                <td colSpan={4}>
                                    <p className='py-3 text-center'>작성된 상담내용이 없습니다.</p>
                                </td>
                            </tr>
                        )
                            : (
                                <tr>
                                    <td colSpan={4}>
                                        <p className='py-3 text-center lh-lg'>
                                            검색어: <b>{searchTerm}</b> <br />
                                            검색된 상담내용이 없습니다.
                                        </p>
                                    </td>
                                </tr>
                            )
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={4}>
                            <div className='text-center'>
                                <TablePagination handlePageClick={handlePageClick} pageCount={pageCount} />
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div >
    )
}

export default SchoolRecordVer2List